import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Swiper as SwiperType } from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { H3, Image, P } from "../../../../AbstractElements";
import { darkVariantData, darkVariantSubTitle } from "../../../../Data/BonusUiData/CarouselData";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { DarkVariantTitle } from "../../../../Utils/Constants";

export default function DarkVariant() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Col xl={6} sm={12}>
      <Card className="height-equal">
        <CommonCardHeader headClass="pb-0" title={DarkVariantTitle} subTitle={darkVariantSubTitle} />
        <CardBody>
          <div className="carousel-dark">
            <Swiper modules={[Navigation, Pagination]} navigation pagination={{ clickable: true }} loop slidesPerView={1} onSlideChange={(swiper: SwiperType) => setActiveIndex(swiper.realIndex)}>
              {darkVariantData?.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className={`carousel-item ${index === activeIndex ? "active" : ""}`}>
                    <Image src={dynamicImage(slide.image)} alt="drawing-room" className="d-block w-100" />
                    <div className="carousel-caption d-none d-md-block carousel-opacity">
                      <H3>{slide.captionHeader}</H3>
                      <P>{slide.captionText}</P>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
